import { defineStore } from "pinia";
import { useCookie } from "#app";

export const useLanguagesStore = defineStore("languages", {
  state: () => ({
    selectedLanguage: useCookie("preferredLanguage").value || null, // Иницијално null
    initialLanguageSet: false, // Прати да ли је иницијални језик постављен
  }),
  actions: {
    setSelectedLanguage(lang: string) {
      this.selectedLanguage = lang;
      useCookie("preferredLanguage").value = lang;
    },
    async detectUserLanguageByIP() {
      if (this.initialLanguageSet) return; // Већ смо поставили језик, не треба поново

      try {
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();

        let detectedLanguage = "en"; // Подразумевани језик

        if (data.country === "NO") {
          detectedLanguage = "no";
        }

        this.setSelectedLanguage(detectedLanguage);
      } catch (error) {
        console.error("Error detecting language by IP:", error);
        // Овде можеш да користиш неки резервни језик или да прикажеш поруку кориснику
        this.setSelectedLanguage("en"); // или неки други језик
      } finally {
        this.initialLanguageSet = true; // Означавамо да смо поставили иницијални језик
      }
    },

    initializeLanguage() {
      // Прво, покушај да узмеш језик из cookie-ја
      const preferredLanguage = useCookie("preferredLanguage").value;

      if (preferredLanguage) {
        this.setSelectedLanguage(preferredLanguage);
        this.initialLanguageSet = true; // Ако постоји у cookie-ју, сматрамо да је иницијални језик постављен
        return; // Прекидамо даље извршавање
      }

      // Ако нема језика у cookie-ју, детектујемо га по IP адреси
      this.detectUserLanguageByIP();
    },
  },
  getters: {
    getSelectedLanguage: (state) => state.selectedLanguage || "en", // Враћа "en" ако је selectedLanguage null
  },
});
